import type {SearchItem} from '@myfm/domain';
import {SearchExcerpt,searchExcerptText} from '../ui/SearchExcerpt';
import {formatDateOnly} from '../dates';

export function SearchResultLine({item,query}:{item:SearchItem;query:string}){
 const context=item.context;
 const metadata=[item.detail||'No reference recorded',item.match,
  ...(context?[context.buildings.join(' · ')||'No confirmed building relationship',context.status||'Status not recorded',
   context.updatedAt?`Updated ${formatDateOnly(new Date(context.updatedAt).toISOString().slice(0,10))} (UTC)`:'Update date not recorded',
   context.domain,context.kind,...context.premises??[],...context.parties??[]]:[])].filter(Boolean).join(' · ');
 return <div className="search-result-line"><strong><SearchExcerpt text={item.label} query={query}/></strong>
  <span className="search-result-context">{context?.snippet&&<span className="search-snippet" title={searchExcerptText(context.snippet,true)}><SearchExcerpt text={context.snippet} query={query} extracted/></span>}
   <span className="search-result-metadata" title={metadata}><SearchExcerpt text={metadata} query={query}/></span>
  </span>
 </div>;
}
